'use strict';

export function UserResource($resource) {
  'ngInject';

  return $resource('../../database/users.json', {
    id: '@_id'
  }, {
    changePassword: {
      method: 'PUT',
      params: {
        controller: 'password'
      }
    },
    get: {
      method: 'GET',
      params: {
        id: 'me'
      }
    }
  });
}



// WEBPACK FOOTER //
// ./client/components/auth/user.service.js